export const CLIENT_EXTENSIONS = [
  '.scss',
  '.css',
  '.svg',
  '.png',
  '.jpg',
  '.eot',
  '.ttf',
  '.woff',
  '.woff2',
]
